module.exports = __webpack_public_path__ + "static/media/Entertainment.00874d85.svg";